import styled from 'styled-components';

export const DatePickerContainer = styled.div<{invalid: boolean}>`
  & .react-date-picker {
    display: inline-flex;
    position: relative;
    width: 100%;
    border: 1px solid #DEE2E6;
    border-radius: 8px;
  }
  & .react-date-picker,
  & .react-date-picker *,
  & .react-date-picker *:before,
  & .react-date-picker *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  & .react-date-picker--open {
    border-color: #0055FB;
  }
  & .react-date-picker--disabled {
    background-color: #f0f0f0;
    color: #6d6d6d;
  }
  & .react-date-picker__wrapper {
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    border: thin solid gray;
    width: 100%;
    height: 48px;
    border: none;
    border-radius: 8px;
    background-color: #ffffff;
    outline: none;
    align-items: center;
    font-size: 16px;
    line-height: 24px;
    padding: 12px 16px;
    :hover,
    :focus {
      border-color: #0055FB;
    }
  }

  & .react-date-picker__inputGroup {
    min-width: calc((4px * 3) + 0.54em * 8 + 0.217em * 2);
    flex-grow: 1;
    padding: 0 2px;
    box-sizing: content-box;
  }
  & .react-date-picker__inputGroup__divider {
    padding: 1px 0;
    white-space: pre;
  }
  & .react-date-picker__inputGroup__input {
    min-width: 0.54em;
    height: 100%;
    position: relative;
    padding: 0 1px;
    border: 0;
    background: none;
    font: inherit;
    box-sizing: content-box;
    -moz-appearance: textfield;
  }
  & .react-date-picker__inputGroup__input::-webkit-outer-spin-button,
  & .react-date-picker__inputGroup__input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  & .react-date-picker__inputGroup__input:invalid {
    background: rgba(255, 0, 0, 0.1);
  }
  & .react-date-picker__inputGroup__input--hasLeadingZero {
    margin-left: -0.54em;
    padding-left: calc(1px + 0.54em);
  }
  & .react-date-picker__button {
    border: 0;
    background: transparent;
    padding: 4px 6px;
  }
  & .react-date-picker__button:enabled {
    cursor: pointer;
  }
  & .react-date-picker__button:enabled:hover .react-date-picker__button__icon,
  & .react-date-picker__button:enabled:focus .react-date-picker__button__icon {
    stroke: #0078d7;
  }
  & .react-date-picker__button:disabled .react-date-picker__button__icon {
    stroke: #6d6d6d;
  }
  & .react-date-picker__button svg {
    display: inherit;
  }
  & .react-date-picker__calendar {
    max-width: 100vw;
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1;
    margin-top: 4px;

    @media (min-width: 600px) {
      width: 350px;
    }
  }
  & .react-date-picker__calendar--closed {
    display: none;
  }
  & .react-date-picker__calendar .react-calendar {
    border-width: thin;
    border: 1px solid #DEE2E6;
    background-color: #ffffff;
    padding: 16px;
    border-radius: 0 0 16px 16px;
  }
  
  & input,
  & span {
    color: #6c757d !important; 
  }

  & button {
    border: none;
    font-weight: 400;
    font-size: 18px;
    line-height: 28px;
    background-color: #ffffff;

    :hover {
      cursor: pointer;
    }
  }
  & react-calendar__tile react-calendar__year-view__months__month {
    padding: 16px;
  }
  & .react-calendar__month-view__weekdays,
  & .react-calendar__month-view__days {
    gap: 4px;
    justify-content: center;
    justify-content: space-around;
  }
  & .react-calendar__month-view__days__day {
    height: 40px;
    width: 40px;
    padding: 0;
    flex: none!important;
  }
  & .react-calendar__month-view__weekdays__weekday {
    flex: none!important;
  }
  & .react-calendar__tile--rangeStart, 
  & .react-calendar__tile--rangeEnd,
  & .react-calendar__tile--rangeBothEnds,
  & .react-calendar__month-view__days__day:hover {
    background-color: #0055FB;
    border-radius: 50%;
    color: white;
    cursor: pointer;
  }
  & .react-calendar__month-view__days__day:hover {
    opacity: 0.5;
  }

  & .react-calendar__navigation {
    height: 40px;
    align-items: center;
    display: flex;
  }

  & svg {
    stroke: #6C757D !important;
  }

  & .react-calendar__century-view__decades__decade {
    font-size: 14px;
  }
  & .react-calendar__century-view__decades__decade,
  & .react-calendar__year-view__months__month,
  & .react-calendar__decade-view__years__year {
    font-size: 14px;
    :hover {
      background-color: #0055FB;
      color: white;
      border: none;
      border-radius: 8px;
    }
  }

  ${props => props.invalid && `
    & .react-date-picker__wrapper {
      background-color: #FDEAEB !important;
      border-color: #FCD6D8 !important;
      outline: none !important;
    }
  `}
`;
